<template>
  <GradientBorder class="min-w-40">
    <div
      class="flex px-4 py-2 gap-x-2 rounded-t-2xl bg-black/30 rounded-b-none m-[2px] justify-between border-b border-neutral-500 text-white font-semibold"
    >
      {{ legend.name }}
    </div>

    <div class="flex flex-col gap-2.5 text-white text-sm pl-4 py-5 pr-8">
      <div v-for="(category, idx) in legend.categories" :key="idx" class="flex flex-row gap-3 items-center">
        <VColorPicker
          v-model="category.color"
          :default-color="legend.categories[idx].color as string"
          class="rounded-md"
          :class="{
            'outline-none outline-green-speaker': isGradeBinActive && selectedColorId === category.id,
            'outline-2 hover_outline hover_outline-green-speaker': isGradeBinActive,
          }"
          transform="translateX(-250px)"
          resettable
          :disabled="!isGradeBinActive"
          :is-picker-active="isGradeBinActive && defaultColor?.id === category.id"
          @click="selectedColorId = category.id as string"
          @update:model-value="handleColorUpdate(legend.id as string, idx, $event)"
        >
          <div :style="`background-color: ${category.color};`" class="w-6 h-6 rounded-md" />
        </VColorPicker>
        <div class="flex">{{ category.display_name }}</div>
      </div>
    </div>
  </GradientBorder>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import type { CategoricalLegend } from '~/entities/drillHole'
import type { Color } from '@/composables/useDrillHoleSettings'

const props = defineProps({
  legend: {
    type: Object as PropType<CategoricalLegend>,
    required: true,
  },
  defaultColor: {
    type: Object as PropType<Color | null>,
    default: null,
  },
  isGradeBinActive: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
})

const emit = defineEmits(['select-color'])

const selectedColorId = ref<string | null>(null)

function handleColorUpdate(id: string, idx: number, newColor: string) {
  selectedColorId.value = props.legend.categories[idx].id as string
  emit('select-color', { id, idx, newColor })
}
</script>
